import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import CoreLogic from './components/CoreLogic';
import ProfitMechanism from './components/ProfitMechanism';
import FundManagement from './components/FundManagement';
import TechAdvantage from './components/TechAdvantage';
import ProductNarrative from './components/ProductNarrative';
import ProfitFlywheel from './components/ProfitFlywheel';
import SystemArchitecture from './components/SystemArchitecture';
import TradingExample from './components/TradingExample';
import CrossPlatformArbitrage from './components/CrossPlatformArbitrage';
import MathAlgorithm from './components/MathAlgorithm';
import MathAlgorithmProfit from './components/MathAlgorithmProfit';
import SafuFund from './components/SafuFund';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0c0814]">
      <Navbar />
      <Hero />
      <CoreLogic />
      <ProfitMechanism />
      <FundManagement />
      <TechAdvantage />
      <ProductNarrative />
      <ProfitFlywheel />
      <SystemArchitecture />
      <TradingExample />
      <CrossPlatformArbitrage />
      <MathAlgorithm />
      <MathAlgorithmProfit />
      <SafuFund />
      <CTA />
      <Footer />
    </div>
  );
}